export const enum Protocol {
  http = 'http://',
  https = 'https://',
}

export const prefix = Protocol.https


export const EXTERNAL_URL_RELEASE = {
  pague_la: 'https://app.dev.pague.la',
  sign_view: 'https://assine.actuar.com',
}

export const APP_URL_RELEASE = {
  accounts: prefix + 'accounts.rc.actuar.dev',
  actuar_app: prefix + 'app.rc.actuar.dev',
  treino_app: prefix + 'treino.rc.actuar.dev',
  actuar_sign: prefix + 'sign.rc.actuar.dev',
  afig_app: prefix + 'app.afig.rc.actuar.dev',
  actuar_acesso: prefix + 'acesso.rc.actuar.dev',
  facilfit_app: prefix + 'app.facilfit.com.br',
  face_detection_app: prefix + 'faceid.rc.actuar.com',
}

export const API_RELEASE_ACTUAR = {
  odata: prefix + 'odata.prd.g.actuar.cloud',
  odata_goods_service: prefix +'goodservice-api.prd.g.actuar.cloud/Odata',
  odata_person_service: prefix +'personservice-api.prd.g.actuar.cloud/Odata',
  odata_payable_service: prefix +'payableservice-api.prd.g.actuar.cloud/Odata',
  odata_work_service: prefix +'workservice-api.prd.g.actuar.cloud/Odata',
  odata_crm_service: prefix +'crmservice-api.prd.g.actuar.cloud/Odata',
  odata_generalfinance_service: prefix + 'generalfinanceservice-api.prd.g.actuar.cloud/Odata',
  odata_account_service: prefix + 'accountservice-api.prd.g.actuar.cloud/Odata',
  odata_receivable_service: prefix +'receivableservice-api.prd.g.actuar.cloud/Odata',
  odata_email_service: prefix +'emailservice-api.prd.g.actuar.cloud/Odata',
  odata_contract: prefix +'contractservice-api.prd.g.actuar.cloud/Odata',
  odata_user_service: prefix + 'userservice-api.prd.g.actuar.cloud/Odata',
  odata_workout_service: prefix + 'workoutservice-api.prd.g.actuar.cloud/Odata',
  odata_post_service: prefix + 'postservice-api.prd.g.actuar.cloud/Odata',
  odata_activity_service: prefix + 'activityservice-api.prd.g.actuar.cloud/Odata',
  odata_addresses_service: prefix + 'addressservice-api.prd.g.actuar.cloud/Odata',
  odata_booking_service: prefix + 'bookingservice-api.prd.g.actuar.cloud/Odata',
  odata_graduation_service: prefix + 'graduationservice-api.prd.g.actuar.cloud/Odata',
  odata_data_service: prefix + 'dataservice-api.prd.g.actuar.cloud/Odata',
  odata_subscription_service: prefix + 'subscriptionservice-api.prd.g.actuar.cloud/Odata',
  odata_physical_assessment_service: prefix + 'physicalassessmentservice-api.prd.g.actuar.cloud/Odata',
  odata_helpdesk_service: prefix + 'helpdeskservice-api.prd.g.actuar.cloud/Odata',
  odata_hotsite_service: prefix + 'hotsiteservice-api.prd.g.actuar.cloud/Odata',
  odata_consumption_log_service: prefix + 'consumptionlogservice-api.prd.g.actuar.cloud/Odata',
  odata_access_log_service: prefix + 'accesslogservice-api.prd.g.toletus.cloud/Odata',
  base: prefix +'actuar-api.prd.g.actuar.cloud',
  paguela: prefix +'paguela-api.prd.g.actuar.cloud',
  api_cep: prefix +'cep-api.prd.g.actuar.cloud',
  auth: prefix +'authentication-api.prd.g.actuar.cloud',
  chat: prefix +'chat-api.prd.g.actuar.cloud',
  file_manager: prefix +'filegroup-api.prd.g.actuar.cloud',
  treino: prefix +'treino-api.prd.g.actuar.cloud',
  facial: prefix +'facial-api.prd.g.actuar.cloud',
  acesso: prefix +'acesso-api.prd.g.actuar.cloud',
  caixa: prefix +'caixa-api.prd.g.actuar.cloud',
  helpdesk: prefix +'helpdeskservice-api.prd.g.actuar.cloud',
  ajustes: prefix +'tst.actuar.net/actuar',
  files_api: prefix +'files-api.prd.g.actuar.cloud',
  contract: prefix +'contractservice-api.prd.g.actuar.cloud',
  billing: prefix +'billing-api.prd.g.actuar.cloud',
  gympass: prefix +'gympass-api.prd.g.actuar.cloud',
  client_notification: prefix +'clientnotification-api.prd.g.actuar.cloud',
  invoicer: prefix +'invoicer-api.prd.g.actuar.cloud',
  acessoLocalhost: Protocol.http + 'localhost:63312',
  userService: prefix +'userservice-api.prd.g.actuar.cloud',
  personService: prefix +'personservice-api.prd.g.actuar.cloud',
  file_group: prefix +'filegroup-api.prd.g.actuar.cloud',
  account_service: prefix + 'accountservice-api.prd.g.actuar.cloud',
  goods: prefix + 'goodservice-api.prd.g.actuar.cloud',
  payable_service: prefix + 'payableservice-api.prd.g.actuar.cloud',
  workService: prefix + 'workservice-api.prd.g.actuar.cloud',
  crm_service: prefix + 'crmservice-api.prd.g.actuar.cloud',
  generalfinance_service: prefix + 'generalfinanceservice-api.prd.g.actuar.cloud',
  receivable_service: prefix + 'receivableservice-api.prd.g.actuar.cloud',
  subscription_service: prefix + 'subscriptionservice-api.prd.g.actuar.cloud',
  email_service: prefix + 'emailservice-api.prd.g.actuar.cloud',
  consummation: prefix + 'consummation-api.prd.g.actuar.cloud',
  workout_service: prefix + 'workoutservice-api.prd.g.actuar.cloud',
  workout_view: prefix + 'workoutviewservice-api.prd.g.actuar.cloud',
  post_service: prefix + 'postservice-api.prd.g.actuar.cloud',
  activity_service: prefix + 'activityservice-api.prd.g.actuar.cloud',
  booking_service: prefix + 'bookingservice-api.prd.g.actuar.cloud',
  data_service: prefix + 'dataservice-api.prd.g.actuar.cloud',
  addresses_service: prefix + 'addressservice-api.prd.g.actuar.cloud',
  storage_service: prefix + 'storageservice-api.prd.g.actuar.cloud',
  physical_assessment_service: prefix + 'physicalassessmentservice-api.prd.g.actuar.cloud',
  whatsapp_service:  prefix + 'whatsappservice-api.prd.g.actuar.cloud',
  graduation_service: prefix + 'graduationservice-api.prd.g.actuar.cloud',
  totalpass: prefix + 'totalpassservice-api.prd.g.actuar.cloud',
  hotsite: prefix + 'hotsite-api.prd.g.actuar.cloud',
  storage: prefix + 'storage-api.prd.g.actuar.cloud',
  search_service: prefix + 'searchservice-api.prd.g.actuar.cloud',
  file_group_service: prefix + 'filegroupservice-api.prd.g.actuar.cloud',
  hotsite_service: prefix + 'hotsiteservice-api.prd.g.actuar.cloud',
  credit_assessment_service: prefix + 'creditassessmentservice-api.prd.g.actuar.cloud',
  meetings_service: prefix + 'meetingservice-api.prd.g.actuar.cloud',
  access_service: prefix + 'accessservice-api.prd.g.actuar.cloud',
  access_directory_service: prefix + 'accessdirectoryservice-api.prd.g.toletus.cloud',
  consumption_log_service: prefix + 'consumptionlogservice-api.prd.g.actuar.cloud',
  consumption_auth_service: prefix + 'consumptionauthservice-api.prd.g.actuar.cloud',
  access_edge_manager_service: prefix + 'accessedgemanager-api.prd.g.toletus.cloud',
  access_edge_manager_service_grpc: prefix + 'grpc.accessedgemanager-api.prd.g.toletus.cloud',
  spooler: prefix + 'spooler-api.prd.g.actuar.cloud',
  access_log_service: prefix + 'accesslogservice-api.prd.g.toletus.cloud',
}
